const KEY = 'sn_products_v1';

function seed() {
  const items = [
    { id: 1, name: 'Widget A', stock: 25, totalRequired: 50, customersWaiting: 12, description: 'A useful widget', price: 9.99 },
    { id: 2, name: 'Gadget B', stock: 10, totalRequired: 30, customersWaiting: 5, description: 'A handy gadget', price: 19.5 },
    { id: 3, name: 'Thingamajig C', stock: 40, totalRequired: 80, customersWaiting: 20, description: 'Multipurpose thingamajig', price: 5.25 },
  ];
  localStorage.setItem(KEY, JSON.stringify(items));
  return items;
}

export function getAll() {
  const raw = localStorage.getItem(KEY);
  if (!raw) return seed();
  try {
    return JSON.parse(raw);
  } catch (e) {
    return seed();
  }
}

export function getById(id) {
  const items = getAll();
  return items.find((p) => p.id === Number(id));
}

function persist(items) {
  localStorage.setItem(KEY, JSON.stringify(items));
}

export function create(product) {
  const items = getAll();
  const nextId = items.length ? Math.max(...items.map((p) => p.id)) + 1 : 1;
  const newItem = { id: nextId, customersWaiting: 0, ...product };
  items.push(newItem);
  persist(items);
  return newItem;
}

export function update(id, data) {
  const items = getAll();
  const idx = items.findIndex((p) => p.id === Number(id));
  if (idx === -1) return null;
  items[idx] = { ...items[idx], ...data };
  persist(items);
  return items[idx];
}

export function addStock(id, amount) {
  const items = getAll();
  const idx = items.findIndex((p) => p.id === Number(id));
  if (idx === -1) return null;

  const numericAmount = Number(amount) || 0;
  items[idx] = {
    ...items[idx],
    stock: (Number(items[idx].stock) || 0) + numericAmount,
  };
  persist(items);
  return items[idx];
}

export function remove(id) {
  let items = getAll();
  items = items.filter((p) => p.id !== Number(id));
  persist(items);
}

export function totalStock() {
  const items = getAll();
  return items.reduce((s, p) => s + (Number(p.stock) || 0), 0);
}

export default { getAll, getById, create, update, addStock, remove, totalStock };
